import { HeaderKey_Authorization } from '@nu-art/thunderstorm-shared';
export const accountGroupName = 'account';
export const QueryParam_Email = 'userEmail';
export const QueryParam_SessionId = HeaderKey_Authorization;
export const QueryParam_RedirectUrl = 'redirectUrl';
export const HeaderKey_CurrentPage = 'current-page';
//# sourceMappingURL=consts.js.map